angular.module('trainerWebApp.services').factory('refreshSession',
  ['$rootScope', 'Auth', 'accountFeatures', 'accountService', 'accountCustomFields', 'mtypes', 'trackingService', function ($rootScope, Auth, accountFeatures, accountService, accountCustomFields, mtypes, trackingService) {

    function parseResponseData(res) {
      accountCustomFields.setCustomFields(res.customFields);
      $rootScope.trainerFirstName = res.firstName;
      $rootScope.trainerLastName = res.lastName;
      $rootScope.trainerEmail = res.email;
      $rootScope.accountId = res.accountId;
      $rootScope.userId = res.userId;
      $rootScope.yammerEnabled = mfConfig.yammerEnabled && res.accountInfo.yammerEnabled;
      $rootScope.isUsernameEnabled = res.accountInfo.loginMode == mtypes.loginMode.username &&
        (res.accountFeatures.indexOf(mtypes.featureEntry.usernameLogin) != -1 ||
          res.accountTrialFeatures.indexOf(mtypes.featureEntry.usernameLogin) != -1);
      $rootScope.viewAsTraineeUrl = res.viewAsTraineeUrl;
      mfConfig.useGroupRestrictions = res.useGroupRestrictions;
      mfConfig.ownerEmail = res.accountInfo.ownerEmail;

      $rootScope.mfConfig.accountStatus = res.accountStatus;
      $rootScope.mfConfig.accountCancellationDate = res.accountInfo.cancellationDate;
      $rootScope.mfConfig.features = res.accountFeatures.concat(res.globalAccountFeatures);
      $rootScope.mfConfig.trialFeatures = res.accountTrialFeatures;

      accountFeatures.features = res.accountFeatures;
      accountFeatures.pricingType = res.accountInfo.pricingType;
      accountFeatures.setGoodData(!!res.goodDataEnabled, res.goodDataSeriesReportUrlTemplate, res.goodDataTraineesDashboardUrl, res.goodDataClientDashboardUrl);
      accountFeatures.showAdvancedTierFeatures = res.showAdvancedTierFeatures;
      accountFeatures.maxTeamMembers = res.accountInfo.maxTeamMembers;
      accountFeatures.pricingMaxTrainees = res.accountInfo.pricingMaxTrainees;
      accountFeatures.trialDaysLeft = res.accountInfo.trialDaysLeft;
      accountFeatures.advancedTierDaysLeft = res.accountInfo.advancedTierDaysLeft;
      accountFeatures.tierName = res.accountInfo.tierName;
      Auth.setUserPermissions(res.permissions);
      Auth.setUserPrivileges(res.userPrivileges);

      trackingService.setupKissMetrics(res);

      accountService.accountInfo = res.accountInfo;
    }

    function setOptions(value) {
      return value || {
        ignoreInactiveAccount: false
      };
    }

    return {
      refresh: function (options, successCb) {
        options = setOptions(options);
        accountService.getAccountInfo(options, function (res) {
          parseResponseData(res);
          if(successCb) successCb(res);

        }, function (err) {
          if (!err.data) return;
          if (err.data.accountInactive && options.ignoreInactiveAccount)
            return true;
        });
      },

      resource: function(options) {
        return accountService.getAccountInfo(setOptions(options), function(res) {
          parseResponseData(res);
        });
      }
    };
  }]
);
